import React from 'react';
import { motion } from 'framer-motion';
import { AnimatedNumber } from '../AnimatedNumber';
import { DataTag } from './DataTag';
import { DistributionBars } from './DistributionBars';
import type { Interpretation } from '../../data/results';
interface InterpretationBlockProps {
  interpretation: Interpretation;
  accent: string;
  selected: string | null;
  onSelect: (id: string) => void;
}
const ease = [0.22, 1, 0.36, 1] as const;
export function InterpretationBlock({
  interpretation,
  accent,
  selected,
  onSelect
}: InterpretationBlockProps) {
  const choice = interpretation.options.find(o => o.id === selected);
  return <div data-id="element-601" data-mp="3hrpzfhlep5dt">
      <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-pulse-iris" data-id="element-602" data-mp="3hrg5jix8qe2u">Your interpretation</p>
      <h3 className="mt-2 font-serif text-[22px] leading-tight text-navy-900" data-id="element-603" data-mp="3cter5barf2xp">{interpretation.question}</h3>

      {!choice ? <ul className="mt-5 space-y-2.5" data-id="element-604" data-mp="s1ckltehxser">
          {interpretation.options.map((o, i) => <motion.li key={o.id} initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        delay: 0.1 + i * 0.06,
        ease
      }} data-id="element-605" data-mp="2wh5z251xqb1e" data-mpi={i}>
              <button type="button" onClick={() => onSelect(o.id)} className="flex min-h-[56px] w-full items-center gap-3.5 rounded-2xl border border-navy-900/10 bg-white px-4 py-3 text-left shadow-[0_1px_2px_rgba(15,36,66,0.05)] transition hover:shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-pulse-iris" data-id="element-606" data-mp="36g4ycx0t8ubq">
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-navy-900/15 text-[11px] font-semibold text-navy-600" data-id="element-607" data-mp="2mq1n7e7k36as">
                  {String.fromCharCode(65 + i)}
                </span>
                <span className="text-[14px] font-medium leading-snug text-navy-900" data-id="element-608" data-mp="1uzokh84wmlqz">{o.label}</span>
              </button>
            </motion.li>)}
        </ul> : <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      ease
    }} className="mt-5 rounded-3xl border border-navy-900/[0.08] bg-white p-5 shadow-[0_8px_30px_-12px_rgba(15,36,66,0.15)]" aria-live="polite" data-id="element-609" data-mp="32auwtbjqrii6">
          <DataTag kind="interpretation" detail="n = [n]" data-id="element-610" data-mp="3758wvr9cmdt6" />
          <div className="mt-4 flex items-end gap-3" data-id="element-611" data-mp="2jemo1xrispi4">
            <p className="font-serif text-[48px] leading-none text-pulse-iris" data-id="element-612" data-mp="2jfej97h7gl7v">
              <AnimatedNumber value={choice.peerPercent} delay={0.2} data-id="element-613" data-mp="2egbhbvwiuv44" />%
            </p>
            <p className="pb-1.5 text-[11px] font-semibold uppercase leading-tight tracking-[0.14em] text-navy-800" data-id="element-614" data-mp="2sft7aelk0ef2">
              Interpreted it
              <br data-id="element-615" data-mp="7nr518wbpq1x" />
              like you
            </p>
          </div>
          <div className="mt-5" data-id="element-616" data-mp="7q3r9y946mks">
            <DistributionBars options={interpretation.options} accent="#5468D8" highlightId={choice.id} delay={0.4} data-id="element-617" data-mp="3myumcbptf42" />
          </div>
          <div className="mt-5 border-t border-navy-900/5 pt-4" data-id="element-618" data-mp="b559zorlqv8z">
            <DataTag kind="editorial" data-id="element-619" data-mp="g5kpomzcweu4" />
            <p className="mt-2 text-[15px] leading-snug text-navy-900" data-id="element-620" data-mp="g6mc1nltonr5">{interpretation.observation}</p>
          </div>
        </motion.div>}
    </div>;
}